/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: dpdRoEHB1RdkpQGeaRP58K
// Component: RjKk5sv3K_6R

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { AntdSingleCollapse } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { singleCollapseHelpers as AntdSingleCollapse_Helpers } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFooter.module.css"; // plasmic-import: RjKk5sv3K_6R/css

createPlasmicElementProxy;

export type PlasmicFooter__VariantMembers = {};
export type PlasmicFooter__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooter__VariantsArgs;
export const PlasmicFooter__VariantProps = new Array<VariantPropType>();

export type PlasmicFooter__ArgsType = {};
type ArgPropType = keyof PlasmicFooter__ArgsType;
export const PlasmicFooter__ArgProps = new Array<ArgPropType>();

export type PlasmicFooter__OverridesType = {
  footer?: Flex__<"div">;
  collapse?: Flex__<typeof AntdSingleCollapse>;
  h1?: Flex__<"h1">;
  img?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultFooterProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooter__RenderFunc(props: {
  variants: PlasmicFooter__VariantsArgs;
  args: PlasmicFooter__ArgsType;
  overrides: PlasmicFooter__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "collapse.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("open", AntdSingleCollapse_Helpers)
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_dpdRoEHB1RdkpQGeaRP58K",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.footer
      )}
    >
      <div className={classNames("all", sty.freeBox__lCuXe)}>
        <div className={classNames("all", sty.freeBox__zYqQx)}>
          <div className={classNames("all", "__wab_text", sty.text__ctgd6)}>
            {"RPSN a n\u00e1klady \u00fav\u011bru"}
          </div>
          <div className={classNames("all", "__wab_text", sty.text___23Yma)}>
            {
              "RPSN (ro\u010dn\u00ed procentn\u00ed sazba n\u00e1klad\u016f) vyjad\u0159uje celkov\u00e9 ro\u010dn\u00ed n\u00e1klady \u00fav\u011bru jako procento z p\u016fj\u010den\u00e9 \u010d\u00e1stky. Zahrnuje \u00farok i v\u0161echny poplatky, kter\u00e9 jsou sou\u010d\u00e1st\u00ed celkov\u00fdch n\u00e1klad\u016f \u00fav\u011bru, a umo\u017e\u0148uje tak srovnat nab\u00eddky r\u016fzn\u00fdch poskytovatel\u016f.\n\nVa\u0161i \u017e\u00e1dost m\u016f\u017eeme p\u0159edat n\u011bkolika r\u016fzn\u00fdm poskytovatel\u016fm. Konkr\u00e9tn\u00ed \u00farokovou sazbu, RPSN a v\u00fd\u0161i spl\u00e1tky proto nelze ur\u010dit p\u0159edem - stanov\u00ed je v\u017edy poskytovatel po individu\u00e1ln\u00edm posouzen\u00ed va\u0161\u00ed \u00fav\u011bruschopnosti, podle po\u017eadovan\u00e9 v\u00fd\u0161e \u00fav\u011bru, doby spl\u00e1cen\u00ed a va\u0161\u00ed platebn\u00ed historie. Z\u00e1vazn\u00e9 podm\u00ednky najdete v p\u0159edsmluvn\u00edch informac\u00edch a ve smlouv\u011b od poskytovatele. P\u0159e\u010dt\u011bte si je p\u0159ed podpisem.\n\nRozsah nab\u00eddek na\u0161ich partner\u016f: \u00fav\u011bry od 5 000 K\u010d do 300 000 K\u010d, doba spl\u00e1cen\u00ed 3 a\u017e 120 m\u011bs\u00edc\u016f, RPSN od 9,9 % do 5569,4 %. Nejni\u017e\u0161\u00ed sazby jsou dostupn\u00e9 pouze \u010d\u00e1sti \u017eadatel\u016f."
            }
          </div>
          {(() => {
            const child$Props = {
              bordered: true,
              className: classNames("__wab_instance", sty.collapse),
              label2: "Collapse Header",
              onChange: async (...eventArgs: any) => {
                generateStateOnChangePropForCodeComponents(
                  $state,
                  "open",
                  ["collapse", "open"],
                  AntdSingleCollapse_Helpers
                ).apply(null, eventArgs);
              },
              open: generateStateValueProp($state, ["collapse", "open"]),
              rotationAngle: 90,
              showArrow: true
            };
            initializeCodeComponentStates(
              $state,
              [
                {
                  name: "open",
                  plasmicStateName: "collapse.open"
                }
              ],
              [],
              AntdSingleCollapse_Helpers ?? {},
              child$Props
            );

            return (
              <AntdSingleCollapse
                data-plasmic-name={"collapse"}
                data-plasmic-override={overrides.collapse}
                {...child$Props}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__u8Uz)}
                >
                  {"Collapsible text..."}
                </div>
              </AntdSingleCollapse>
            );
          })()}
        </div>
        <div className={classNames("all", sty.freeBox__gaYu1)}>
          <div className={classNames("all", sty.freeBox__ysAlx)}>
            <div className={classNames("all", sty.freeBox__xavEs)}>
              <div className={classNames("all", sty.freeBox__iImjn)}>
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    "all",
                    "h1",
                    "h1__dpdRo",
                    "__wab_text",
                    sty.h1
                  )}
                >
                  {"Kdo jsme"}
                </h1>
                <div
                  className={classNames("all", "__wab_text", sty.text___70ON8)}
                >
                  {
                    "FinBakers s.r.o. je samostatn\u00fd zprost\u0159edkovatel spot\u0159ebitelsk\u00e9ho \u00fav\u011bru podle z\u00e1kona \u010d. 257/2016 Sb., o spot\u0159ebitelsk\u00e9m \u00fav\u011bru. Nejsme poskytovatelem \u00fav\u011bru \u2014 \u00fav\u011br poskytuje a o jeho schv\u00e1len\u00ed rozhoduje v\u017edy konkr\u00e9tn\u00ed partnersk\u00fd poskytovatel.\n\nNa\u0161e opr\u00e1vn\u011bn\u00ed k \u010dinnosti samostatn\u00e9ho zprost\u0159edkovatele spot\u0159ebitelsk\u00e9ho \u00fav\u011bru si m\u016f\u017eete ov\u011b\u0159it v registru \u010cesk\u00e9 n\u00e1rodn\u00ed banky JERRS pod I\u010cO 09151541. Org\u00e1nem dohledu je \u010cesk\u00e1 n\u00e1rodn\u00ed banka, Na P\u0159\u00edkop\u011b 28, 115 03 Praha 1, cnb.cz.\n\nTato str\u00e1nka je reklamou na zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00e9ho \u00fav\u011bru. Nejde o n\u00e1vrh na uzav\u0159en\u00ed smlouvy."
                  }
                </div>
              </div>
            </div>
          </div>
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: "/plasmic/oblibena/images/logoFooterSvg.svg",
              fullWidth: 190,
              fullHeight: 60,
              aspectRatio: undefined
            }}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  footer: ["footer", "collapse", "h1", "img"],
  collapse: ["collapse"],
  h1: ["h1"],
  img: ["img"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  footer: "div";
  collapse: typeof AntdSingleCollapse;
  h1: "h1";
  img: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooter__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooter__VariantsArgs;
    args?: PlasmicFooter__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooter__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooter__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooter__ArgProps,
          internalVariantPropNames: PlasmicFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicFooter";
  } else {
    func.displayName = `PlasmicFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicFooter = Object.assign(
  // Top-level PlasmicFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    collapse: makeNodeComponent("collapse"),
    h1: makeNodeComponent("h1"),
    img: makeNodeComponent("img"),

    // Metadata about props expected for PlasmicFooter
    internalVariantProps: PlasmicFooter__VariantProps,
    internalArgProps: PlasmicFooter__ArgProps
  }
);

export default PlasmicFooter;
/* prettier-ignore-end */
